export const NAME = 'events';


// WEBPACK FOOTER //
// ./src/modules/events/constants.js